import React from "react";
import { useApp } from "@/context/AppProvider";
import { CONTACT } from "@/content";
import { EditableText } from "@/components/editable";

export const Footer = () => {
  const { tr } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="py-12" style={{ backgroundColor: "var(--ink)" }}>
      <div className="container-lux flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <p className="font-display text-2xl text-white">Ali<span style={{ color: "var(--gold)" }}>.</span>Inkis</p>
          <EditableText as="p" path={["footer", "built"]} value={tr.footer.built} className="text-sm mt-1 block" style={{ color: "rgba(255,255,255,0.5)" }} />
        </div>
        <div className="flex items-center gap-6">
          <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="text-sm transition-colors hover:text-white" style={{ color: "rgba(255,255,255,0.6)" }}>LinkedIn</a>
          <a href={`mailto:${CONTACT.email}`} className="text-sm transition-colors hover:text-white" style={{ color: "rgba(255,255,255,0.6)" }}>{CONTACT.email}</a>
        </div>
        <p className="text-xs" style={{ color: "rgba(255,255,255,0.4)" }}>© {year} · {tr.footer.rights}</p>
      </div>
    </footer>
  );
};
